import {FaRegLightbulb} from "react-icons/fa6";

import {FormLabel} from "@/components/form/FormLabel.tsx";
import {Select} from "@/components/select/Select.tsx";
import {BrandInfo} from "@/lib/queries/accounts.ts";
import {WidgetEntity} from "@/lib/queries/statuspages.ts";
import {WidgetTheme, WidgetThemeName} from "@/pages/tools/theme.js.ts";
import {WidgetEntitySelect} from "@/pages/tools/WidgetEntitySelect.tsx";

const LinkOptions = [{value: "", label: "Statistics Page"}];

interface UptimeWidgetFormProps {
  className?: string;
  brand: BrandInfo;
  onLinkSelected: (link: string) => void;
  theme: WidgetTheme;
  onSetTheme: (theme: WidgetTheme) => void;
  value?: WidgetEntity;
  onSelected: (value: WidgetEntity) => void;
}

export const UptimeWidgetForm = ({
  className,
  value,
  brand,
  onLinkSelected,
  onSelected,
  onSetTheme,
}: UptimeWidgetFormProps) => (
  <div className={className}>
    <p>
      <span className="me-1">
        <FaRegLightbulb className="me-1" />
        <strong>Need Help?</strong>
      </span>
      <span className="me-1">See our</span>
      <a
        data-zd-article-id="true"
        target="_blank"
        href="https://support.uptime.com/hc/en-us/articles/360001342779-Using-the-Uptime-Widget"
      >
        Uptime Widget support article
      </a>
      .
    </p>
    <p>
      The Uptime Widget allows you to provide users with transparency into your website's uptime statistics. To get
      started, you will simply select your status page or check and theme from below, then place the embedded code
      within the footer of your website.
    </p>
    <form>
      <div className="form-group mb-2">
        <FormLabel forId="entity_url" helpText={"Type to search"}>
          Status Page/Check
        </FormLabel>
        <WidgetEntitySelect value={value} onChange={(widget) => widget && onSelected(widget)} />
      </div>
      <div className="mb-2">
        <FormLabel forId="id_theme">Theme</FormLabel>
        <Select
          name={"theme"}
          id="id_theme"
          inputId={"id_theme"}
          defaultValue={{value: WidgetTheme.Light}}
          getOptionLabel={(option) => WidgetThemeName[option.value]}
          getOptionValue={(option) => option.value}
          onChange={(theme) => theme && onSetTheme(theme.value)}
          options={Object.values(WidgetTheme).map((theme) => ({
            value: theme,
          }))}
        />
      </div>
      <div className="">
        <FormLabel forId="id_link">Link To</FormLabel>
        <Select
          id="id_link"
          name="link"
          inputId="id_link"
          defaultValue={LinkOptions[0]}
          onChange={(link) => link && onLinkSelected(link.value)}
          options={[...LinkOptions, ...[{value: brand.siteURL, label: "Homepage"}]]}
        />
      </div>
    </form>
  </div>
);
